// Glossário do Copilot (5 abas, 02/09/2026): fonte única dos termos que a tela
// explica em tooltip. Cada termo tem TITULO, TEXTO e EXEMPLO em
// CAPTAIN.GLOSSARIO.<TERMO> nos dois idiomas; o spec cobra os dois.
export const TERMOS_GLOSSARIO = [
  'BRIEFING',
  'ACAO',
  'CENARIO',
  'FAQ',
  'PROTECAO',
  'JEITO_DE_FALAR',
  'MODO',
  'TRANSFERENCIA',
  'ENCERRAMENTO',
  'PRODUTO',
  'NOME_DE_EXIBICAO',
];

export const chaveGlossario = (termo, campo = 'TEXTO') =>
  `CAPTAIN.GLOSSARIO.${termo}.${campo}`;

export const ehTermo = termo => TERMOS_GLOSSARIO.includes(termo);
